import React, {useEffect, useState} from "react";
import {toast} from "react-toastify";
import {Spinner} from "../../../../shared";
import FullReviewItem from "../../../../cap17drive/movies/full-review-item/full-review-item";
import './my-profile-reviews.scss';
import {SquadflixReviewsApi} from "../../../../../apis/squadflix-reviews/SquadflixReviewsApi";

type Props = {
    uid: string;
}

const MyProfileReviews = ({uid}: Props) => {

    const [loading, setLoading] = useState(false);
    const [reviews, setReviews] = useState([]);

    useEffect(() => {
        setLoading(true);
        SquadflixReviewsApi.find({uid}).then(res => {
            setReviews(res.results);
        }).catch(() => {
            toast.error("Ha habido un error recuperando las reviews para el usuario " + uid);
        }).finally(() => {
            setLoading(false);
        })
    }, [uid]);


    if (loading) {
        return <div className="d-flex justify-content-center align-items-center" style={{height: '20vh'}}>
            <Spinner/>
        </div>
    }

    return <div className="my-profile-reviews">
        <div className="tmdb-item-reviews">
            {reviews.map((review) => (
                <FullReviewItem key={review.id} review={review}/>
            ))}
        </div>
    </div>;
}

export default MyProfileReviews;
